import { createFileRoute } from '@tanstack/react-router';
import { RequireService } from '@/components/shared/require-service';
import { UsersPage } from '@/features/users/users-page';

export const Route = createFileRoute('/_app/settings/users')({
  component: () => (
    <RequireService service="USER_LIST">
      <UsersPage />
    </RequireService>
  ),
});
